import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-media" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "flex gap-4" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import type {
  ConsoleType,
  ConsolePayloadType,
} from "@/common/types/console/console";

import {
  baseDate,
  baseInput,
  baseSelect,
  baseTextEditor,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-console',
  props: {
    data: {},
    isPatch: { type: Boolean }
  },
  emits: ["update:data", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  name: "",
  type: "CONSOLE",
  status: "INACTIVE",
  is_main: 0,
  is_official: 0,
  is_system: 0,
  description: "",
};

const payload = ref<ConsolePayloadType>({ ...DEFAULT_DATA });

const optionsStatus = computed(() => [
  {
    option: t("common.labels.active"),
    value: "ACTIVE",
  },
  {
    option: t("common.labels.inactive"),
    value: "INACTIVE",
  },
]);

const optionsType = computed(() => [
  {
    option: t("common.labels.arcade"),
    value: "ARCADE",
  },
  {
    option: t("common.labels.console"),
    value: "CONSOLE",
  },
  {
    option: t("common.labels.microcomputer"),
    value: "MICROCOMPUTER",
  },
]);

const optionsYesNot = computed(() => [
  {
    option: t("common.labels.yes"),
    value: 1,
  },
  {
    option: t("common.labels.not"),
    value: 0,
  },
]);

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { name, status, is_official, is_system, is_main, description, type } =
    props.data;

  payload.value = {
    ...payload.value,
    name,
    status,
    is_main,
    is_official,
    is_system,
    type,
    description,
  };
}

function maskSlug(data: string) {
  return data?.replaceAll(" ", "-")?.toLowerCase();
}

function maskYear(data: string) {
  return data?.replace(/\D/g, "")?.replaceAll(" ", "");
}

const debouceUpdate = debounce(update, 500);

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('name')))
      ],
      value: payload.value.name,
      placeholder: _unref(t)('media.placeholders.name'),
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("media.labels.name")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event)),
        value: payload.value.status,
        options: optionsStatus.value,
        "is-empty": false,
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(debouceUpdate)('status')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.type) = $event)),
        value: payload.value.type,
        options: optionsType.value,
        "is-empty": false,
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(debouceUpdate)('type')))
      }, {
        label: _withCtx(() => [...(_cache[14] || (_cache[14] = [
          _createTextVNode(" Plataforma ", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.is_main,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.is_main) = $event)),
        value: payload.value.is_main,
        options: optionsYesNot.value,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(debouceUpdate)('is_main')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("collection.labels.is_main")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.is_system,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.is_system) = $event)),
        value: payload.value.is_system,
        options: optionsYesNot.value,
        "is-empty": false,
        onChange: _cache[9] || (_cache[9] = ($event: any) => (_unref(debouceUpdate)('is_system')))
      }, {
        label: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createTextVNode(" É um Sistema? ", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.is_official,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.is_official) = $event)),
        value: payload.value.is_official,
        options: optionsYesNot.value,
        "is-empty": false,
        onChange: _cache[11] || (_cache[11] = ($event: any) => (_unref(debouceUpdate)('is_official')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("collection.labels.is_official")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": [
        _cache[12] || (_cache[12] = ($event: any) => ((payload.value.description) = $event)),
        _cache[13] || (_cache[13] = ($event: any) => (_unref(debouceUpdate)('description')))
      ]
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("media.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})